exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rd-snackbar-container{position:fixed;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);z-index:10000;bottom:0}.rd-snackbar{display:block;position:relative;width:auto;opacity:0;bottom:-100px;padding:8px 12px;background-color:var(--card-background);border-color:var(--card-background);-webkit-box-shadow:var(--card-box-shadow);box-shadow:var(--card-box-shadow);border-radius:5px;-webkit-transition:all .5s ease;transition:all .5s ease;-webkit-transition-property:top,right,bottom,left,opacity;transition-property:top,right,bottom,left,opacity;margin-bottom:20px}.rd-snackbar.show{bottom:20px;opacity:1}.rd-snackbar img{height:44px;width:44px;-o-object-fit:cover;object-fit:cover;border-radius:5px}.rd-snackbar-body{min-width:156px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-603b8a5f","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/views/rd/assets/js/v2/components/misc/snackbar.vue
// module id = x2Ku
// module chunks = 6 33 40 43 46 49